export default "__VITE_PUBLIC_ASSET__14d2414c__"